import {login, logout, getInfo, logoutwx} from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {getDomain} from "@/api/saas";
const user = {
    state: {
        token: getToken(),
        name: '',
        nickName:'',
        avatar: '',
        roles: [],
        permissions: [],
        user_type:'10',
        languageType:'ru',
        deptId:"",
        webdata:{yuyan:[],web:[],data:[]}
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_NAMEs: (state, name) => {
            state.nickName = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_user_type: (state, roles) => {
            state.user_type = roles
        },
        SET_languageType: (state, roles) => {
            state.languageType = roles
        },
        SET_Web: (state, data) => {
            state.webdata = data
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        },
        SET_DEPTID: (state, deptId) => {
    state.deptId = deptId
},
    },

    actions: {
        wxLogin({ commit }, token){
            setToken(token)
            commit('SET_TOKEN', token)
        },
        // 登录
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password
            const code = userInfo.code
            const uuid = userInfo.uuid
            const openid=userInfo.openid
            return new Promise((resolve, reject) => {
                login(username, password, code, uuid,openid).then(res => {
                    setToken(res.token)
                    commit('SET_TOKEN', res.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    const user = res.user
                    const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/profile.png") : 'http://file.global86.cn/' + user.avatar;
                    if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                        commit('SET_ROLES', res.roles)
                        commit('SET_PERMISSIONS', res.permissions)
                    } else {
                        commit('SET_ROLES', ['ROLE_DEFAULT'])
                    }
                    commit('SET_NAME', user.userName)
                    commit('SET_NAMEs', user.nickName)
                    commit('SET_DEPTID',user.deptId);
                    commit('SET_AVATAR', avatar)
                    commit('SET_user_type',user.userType)
                    var type=localStorage.getItem("languageType");
                    commit('SET_languageType',type)
                    getDomain().then(ress=>{
                        let acweb=[];
                        let acyuyan=[];
                        ress.data=ress.data.reverse();
                        ress.data.forEach(item=>{
                            acyuyan.push(item.languageType)
                            acweb.push(item.websiteRealmName)
                        })
                        commit('SET_Web', {yuyan:acyuyan,web:acweb,data:ress.data})
                        resolve(res)
                    })
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 退出系统
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    commit('SET_PERMISSIONS', [])
                    commit('SET_user_type','')
                    commit('SET_languageType','')
                    localStorage.setItem("languageType",'')
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },



        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        }
    }
}

export default user
